import React from "react";
import { useState, useEffect } from "react";
import './index.scss'
import ArrowButton from "../ArrowButton";

const PopUp = ({ title, description, linkText, link }) => {

    const [popup, setPopup] = useState(1);

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                setPopup(false);
            }
        };

        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    function handlePopup() {
        setPopup(prevState => !prevState);
    }

    const handleButtonClick = () => {
        window.location.href = "mailto:bewerbung@holzweg.com";
    };

    return (
        <>
            {popup && (
                <div className="popup__overlay"></div>
            )}

            <div className={`popup ${!popup ? 'popup__closing' : ''}`}>
                <h1>
                    {title}
                </h1>

                <span className='popup__description'>
                    {description}
                </span>

                <button className="cta-round" onClick={handleButtonClick}>
                    <span>
                        <a>{linkText}</a>
                    </span>
                    <svg viewBox="0 0 13 10" height="10px" width="15px">
                        <path d="M1,5 L11,5"></path>
                        <polyline points="8 1 12 5 8 9"></polyline>
                    </svg>
                </button>
                <div className="popup__close" onClick={handlePopup}>
                    <span className="line"></span>
                    <span className="line"></span>
                </div>
            </div>
        </>
    )
}

export default PopUp